export { default } from '../../../rewards/list/[rewardId]';
export * from '../../../rewards/list/[rewardId]';
